export default "__VITE_ASSET__CULVplHp__"